import api from './api'

export const rbacService = {
  getRoles: (email?: string) => api.post('/api/getAdminRbacState', { email }),

  getRoleById: (id: string, email?: string) =>
    rbacService.getRoles(email).then((response: any) => ({
      ...response,
      data: {
        ...response.data,
        role: response.data?.roles?.[id],
      },
    })),

  createRole: (data: any) => api.post('/api/saveAdminRole', data),

  saveRole: (data: any) => api.post('/api/saveAdminRole', data),

  updateRole: (id: string, data: any) => api.post('/api/saveAdminRole', { ...data, key: id }),

  deleteRole: (id: string) => api.post('/api/deleteAdminRole', { role: id }),

  getPermissions: (email?: string) => api.post('/api/getAdminFeatureAccess', { email }),

  assignRole: (userId: string, roleId: string) =>
    api.post('/api/adminSaveUserProfile', { email: userId, role: roleId }),
}
